---
fr:
  notification_system:
    instant_sender:
      associated_event: Événement associé
      capacity_used: Capacité utilisée
      current_deviation: Écart actuel
      current_energy: Énergie actuelle
      deviation_value: "%{deviation}%"
      energy_mwh: "%{energy} MWh"
      event_component: Composant
      event_started: Commencé
      event_status: Statut
      maximum_capacity: Capacité maximale
      optimization_initiated: L'optimisation de la production a été lancée et la soumission au marché suivra.
      percentage: "%{percentage}%"
      reservoir_energy_status: État énergétique du réservoir
      threshold_setting: Réglage du seuil
      threshold_value: "±%{threshold}%"
      toast_title: Déclenchement InstantSender pour %{power_plant_name}
      trigger_time: Heure de déclenchement
      trigger_type: Type de déclenchement
      trigger_types:
        manual: Déclenchement manuel
        other: Autre
        water_level_high: Niveau d'eau élevé
        water_level_low: Niveau d'eau bas
      triggered_for: InstantSender a été déclenché pour %{power_plant_name}
      view_details: Voir les détails dans le plan de simulation de production du Portail.
      water_level: Niveau d'eau
      water_level_masl: "%{level} m.s.m"
